export default __webpack_public_path__ + "static/media/headerbar1.416ffe9d.JPG";